<template>
  <div class="div_home_view">
    <Header
      :options="{
        title: true,
        search: true,
        released: true,
        message: true,
        user: true,
      }"
    />
    <div class="div_scroll" ref="refScroll" @scroll="scrollHandler">
      <!-- 分类 -->
      <TableScroll
        :lable="requestObj.classification"
        :tableData="lableList"
        @change="getHomeData"
      ></TableScroll>
      <div class="div_content">
        <!-- 榜单 -->
        <div class="content_table flex_between">
          <ul class="flex">
            <li
              class="li_table cp_us"
              :class="
                requestObj.orderBy == 0 && requestObj.followed == 0
                  ? 'li_color'
                  : ''
              "
              @click="clickTable('orderBy', 0)"
            >
              最新
            </li>
            <li
              class="li_table cp_us"
              :class="
                requestObj.orderBy == 1 && requestObj.followed == 0
                  ? 'li_color'
                  : ''
              "
              @click="clickTable('orderBy', 1)"
            >
              热榜
            </li>
            <li
              v-if="user"
              class="li_table cp_us"
              :class="requestObj.followed == 1 ? 'li_color' : ''"
              @click="clickTable('followed', 1)"
            >
              关注
            </li>
          </ul>
          <ul class="flex">
            <li
              class="li_table cp_us"
              :class="{ li_color: requestObj.freeOrPaid == item.value }"
              v-for="item in topTable"
              :key="item.title"
              @click="clickTable('freeOrPaid', item.value)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <!-- 内容 -->
        <n-spin :show="loading">
          <ul class="ul_content">
            <n-grid x-gap="18" cols="1 760:2 900:3 1220:4">
              <n-gi v-for="val in homeData" :key="val.fileType + val.id">
                <!-- 卡片内容 -->
                <div class="div_content_item cp_us" @click="clickFileItem(val)">
                  <div class="top flex_between">
                    <section>
                      <h3 class="h3_title">{{ val.title }}</h3>
                      <p>{{ val.cardNum }}学习卡</p>
                    </section>
                    <n-image
                      width="75"
                      height="75"
                      :preview-disabled="true"
                      :lazy="true"
                      style="border-radius: 8px"
                      :src="
                        val.image == ''
                          ? fileImgList[val.fileType].img
                          : val.image +
                            '?x-oss-process=image/resize,w_100,m_lfit'
                      "
                    />
                  </div>
                  <div class="bot flex_between">
                    <section class="flex section_left">
                      <n-avatar
                        round
                        :size="18"
                        :src="
                          val.userHeadimgurl +
                          '?x-oss-process=image/resize,w_54,m_lfit'
                        "
                      />
                      <span class="sp_name">{{ val.userNickname }}</span>
                      <i
                        v-if="val.userConfirmStatus == 3"
                        class="key_icon i_identity"
                        >&#xe7b7;</i
                      >
                    </section>
                    <section class="flex section_right us_no">
                      <span class="sp_icon">
                        <i class="key_icon">&#xe7a7;</i>
                        {{ numberToStr(val.heat) }}
                      </span>
                      <span class="sp_icon">
                        <i class="key_icon">&#xe750;</i>
                        {{ numberToStr(val.collectNum) }}
                      </span>
                      <span
                        v-if="val.freeOrPaid == 0"
                        style="color: #27b151"
                        class="sp_price"
                        >免费</span
                      >
                      <span
                        style="color: #ff4500"
                        class="sp_price"
                        v-else-if="val.freeOrPaid == 1"
                      >
                        {{ val.vipFree == 0 ? "¥" + val.price : "会员免费" }}
                      </span>
                    </section>
                  </div>
                </div>
                <!-- 小班级推荐 v-if="index == 12" -->
                <div class="div_class_line phone_none" v-if="false">
                  <div class="div_class">
                    <div class="top_class flex_between">
                      <h3 class="h3_title us_no">小班级推荐</h3>
                      <span class="sp_more cp_us">更多小班级</span>
                    </div>
                    <ul class="ul_class_list">
                      <li v-for="vc in [1, 2, 3, 4]" :key="vc">
                        <img src="" alt="" />
                        <h4>考研英语二解析</h4>
                        <p>已运营 805 天， 29834 人已加入</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </n-gi>
            </n-grid>
            <None
              v-show="homeData.length <= 0 && !loading"
              :style="{ marginTop: '60px' }"
              title="暂无相关内容哦~"
            ></None>
          </ul>
        </n-spin>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, reactive, ref, onActivated } from "vue";
import { useCounterStore } from "@/stores/counter";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import { useMessage } from "naive-ui";

import None from "@/components/other/none.vue";
import TableScroll from "@/components/home-view/tableScroll.vue";
import Header from "@/components/layout/header.vue";

import { searchCommByPage } from "@/api/file.js";
import { fileImgList, numberToStr } from "@/util/index.js";

const store = useCounterStore();
const message = useMessage();
const router = useRouter();
const route = useRoute();
const { user } = storeToRefs(store);

const lableList = [
  { title: "全部", icon: "\ue762" },
  { title: "考研", icon: "\ue768" },
  { title: "考公", icon: "\ue76d" },
  { title: "K12教育", icon: "\ue765" },
  { title: "语言学习", icon: "\ue76e" },
  { title: "高等教育", icon: "\ue76f" },
  { title: "职业教育", icon: "\ue76a" },
  { title: "终身学习", icon: "\ue76b" },
  { title: "兴趣爱好", icon: "\ue76c" },
  { title: "健康与生活", icon: "\ue763" },
  { title: "科普知识", icon: "\ue769" },
  { title: "文化艺术", icon: "\ue767" },
  { title: "幼儿教育", icon: "\ue766" },
  { title: "其他", icon: "\ue770" },
];
const topTable = ref([
  {
    title: "全部",
    value: -1,
  },
  {
    title: "免费",
    value: 0,
  },
  {
    title: "付费",
    value: 1,
  },
]);
// 请求参数
let requestObj = ref({
  classification: "全部",
  content: "",
  orderBy: 0, //0最新 1热榜
  followed: 0, //0未关注 1已关注
  freeOrPaid: -1, //-1:全部，0:免费，1:付费
  current: 1,
  limit: 40,
});
let allPage = 0; // 总页数
let nextLoad = false; // 下拉加载
let homeData = ref([]); // 显示数据
let loading = ref(false); // 加载状态
let scrollTop = 0; //滚动条位置
// ---ref---
let refScroll = ref(null);

if (route.query.category) {
  requestObj.value.classification = decodeURIComponent(route.query.category);
  router.replace({
    name: "cardHome",
    query: {},
  });
}
getHomeData();

onActivated(() => {
  setTimeout(() => {
    refScroll.value.scrollTo({
      top: scrollTop,
    });
  }, 100);
});

// 获取数据
function getHomeData(data) {
  loading.value = true;
  requestObj.value.current = 1;
  if (data) requestObj.value.classification = data.title;
  searchCommByPage(requestObj.value).then((res) => {
    homeData.value = res.data.records;
    allPage = res.data.pages;
    loading.value = false;
  });
}
function clickTable(key, value) {
  switch (key) {
    case "orderBy":
      requestObj.value.followed = 0;
      requestObj.value.orderBy = value;
      break;
    case "followed":
      requestObj.value.orderBy = 0;
      requestObj.value.followed = value;
      break;
    case "freeOrPaid":
      requestObj.value.freeOrPaid = value;
      break;
  }
  getHomeData();
}
// 触底加载
function scrollHandler(e) {
  scrollTop = e.target.scrollTop;
  if (nextLoad) return;
  if (requestObj.value.current >= allPage) return;
  const bottomDistance =
    e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
  if (bottomDistance < 50) {
    nextLoad = true;
    // 当距离底部小于50像素时触发加载更多数据的操作
    requestObj.value.current += 1;
    searchCommByPage(requestObj.value).then((res) => {
      homeData.value = homeData.value.concat(res.data.records);
      nextTick(() => {
        nextLoad = false;
      });
    });
  }
}
// 点击文件卡片
function clickFileItem(val) {
  router.push({
    name: "filePreview",
    query: { fileType: val.fileType, fileId: val.id },
  });
}
</script>

<style lang='scss' scoped>
.div_home_view {
  width: 100%;
  height: 100%;
  padding-top: 60px;
  box-sizing: border-box;
  overflow: hidden;
  .div_scroll {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
  .div_content {
    width: 100%;
    padding: 10px 60px 0px;
    box-sizing: border-box;
    .content_table {
      .li_table {
        font-size: 18px;
        margin-right: 36px;
        color: #b5b5b5;
        &:last-child {
          margin-right: 0px;
        }
      }
      .li_color {
        font-weight: 600;
        color: #333333;
      }
    }
    .ul_content {
      width: 100%;
      min-height: 300px;
      padding-top: 23px;
      .div_content_item {
        width: 100%;
        padding: 16px 20px;
        margin-bottom: 20px;
        border-radius: 10px;
        border: 1px solid #f0f0f0;
        box-sizing: border-box;
        .top {
          width: 100%;
          height: 80px;
          align-items: flex-start;
          > section {
            width: calc(100% - 90px);
            .h3_title {
              width: 100%;
              font-size: 17px;
              font-weight: 600;
              color: #222222;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
            }
            p {
              font-size: 14px;
              color: #666666;
            }
          }
        }
        .bot {
          margin-top: 8px;
          .section_left {
            flex: 1;
            min-width: 30px;
            .sp_name {
              max-width: calc(100% - 40px);
              font-size: 12px;
              margin-left: 6px;
              color: #5e5e5e;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .i_identity {
              font-size: 14px;
              margin-left: 6px;
              color: #fdb149;
            }
          }
          .section_right {
            white-space: nowrap;
            .sp_icon {
              color: #dddddd;
              font-size: 12px;
              margin-right: 20px;
              i {
                font-size: 15px;
              }
            }
            .sp_price {
              font-size: 12px;
              font-weight: 600;
              color: #000000;
            }
          }
        }
      }
      .div_class_line {
        width: 100%;
        height: 380px;
        margin-bottom: 20px;
        position: relative;
        .div_class {
          position: absolute;
          left: -60px;
          width: 100vw;
          height: 100%;
          padding: 30px 60px 0px;
          background: #f5f5f5;
          box-sizing: border-box;
          .top_class {
            color: #000000;
            .h3_title {
              font-size: 20px;
            }
            .sp_more {
              font-weight: 500;
            }
          }
          .ul_class_list {
            padding-top: 30px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-column-gap: 28px;
            > li {
              background-color: white;
              padding: 30px 0px;
              border-radius: 24px;
              text-align: center;
              img {
                width: 100px;
                height: 100px;
                border-radius: 50%;
              }
              h4 {
                font-size: 20px;
                margin: 8px 0px;
              }
              p {
                font-size: 17px;
                color: #000000;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .div_home_view {
    width: 100%;
    height: 100%;
    padding-top: 60px;
    box-sizing: border-box;
    .div_content {
      width: 100%;
      padding: 10px 30px 0px;
      box-sizing: border-box;
      .content_table {
        .li_table {
          font-size: 17px;
          margin-right: 20px;
          color: #b5b5b5;
        }
        .li_color {
          font-weight: 600;
          color: #333333;
        }
      }
      .ul_content {
        width: 100%;
        min-height: 300px;
        padding-top: 23px;
        .div_content_item {
          width: 100%;
          padding: 16px 20px;
          margin-bottom: 20px;
          border-radius: 10px;
          border: 1px solid #f0f0f0;
          box-sizing: border-box;

          .top {
            width: 100%;
            height: 80px;
            align-items: flex-start;
            > section {
              width: calc(100% - 90px);
              .h3_title {
                width: 100%;
                font-size: 17px;
                font-weight: 600;
                color: #222222;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
              }
              p {
                font-size: 14px;
                color: #666666;
              }
            }
          }
          .bot {
            margin-top: 8px;
            .section_left {
              flex: 1;
              .sp_name {
                max-width: calc(100% - 40px);
                font-size: 12px;
                margin-left: 6px;
              }
            }
            .section_right {
              .sp_icon {
                color: #dddddd;
                font-size: 12px;
                margin-right: 20px;
                i {
                  font-size: 15px;
                }
              }
              .sp_price {
                font-weight: 600;
                font-size: 12px;
                color: #000000;
              }
            }
          }
        }
        .div_class_line {
          width: 100%;
          height: 280px;
          margin-bottom: 20px;
          position: relative;
          .div_class {
            position: absolute;
            left: -30px;
            width: 100vw;
            height: 100%;
            padding: 30px 30px 0px;
            background: #f5f5f5;
            box-sizing: border-box;
            .top_class {
              color: #000000;
              .h3_title {
                font-size: 18px;
              }
              .sp_more {
                font-weight: 500;
              }
            }
            .ul_class_list {
              padding-top: 20px;
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              grid-column-gap: 18px;
              > li {
                background-color: white;
                padding: 20px 6px;
                border-radius: 24px;
                text-align: center;
                img {
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                }
                h4 {
                  font-size: 16px;
                  margin: 4px 0px;
                }
                p {
                  font-size: 13px;
                  color: #000000;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .div_home_view {
    width: 100%;
    height: 100%;
    min-width: auto;
    padding-top: 0.5rem;
    box-sizing: border-box;
    .div_content {
      width: 100%;
      padding: 0.1rem 0.1rem 0rem;
      box-sizing: border-box;
      .content_table {
        .li_table {
          white-space: nowrap;
          font-size: 0.16rem;
          margin-right: 0.2rem;
          color: #b5b5b5;
        }
        .li_color {
          font-weight: 600;
          color: #333333;
        }
      }
      .ul_content {
        width: 100%;
        min-height: 3rem;
        padding-top: 0.15rem;
        .div_content_item {
          width: 100%;
          padding: 0.12rem 0.15rem;
          margin-bottom: 0.1rem;
          border-radius: 0.1rem;
          border: 1px solid #f0f0f0;
          box-sizing: border-box;
          .top {
            width: 100%;
            height: 0.8rem;
            align-items: flex-start;
            > section {
              width: calc(100% - 90px);
              .h3_title {
                width: 100%;
                font-size: 0.17rem;
                font-weight: 600;
                color: #222222;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
              }
              p {
                font-size: 14px;
                color: #666666;
              }
            }
          }
          .bot {
            margin-top: 0.08rem;
            .section_left {
              .sp_name {
                max-width: calc(100% - 0.4rem);
                font-size: 0.12rem;
                margin-left: 0.06rem;
                color: #5e5e5e;
              }
              .i_identity {
                font-size: 0.12rem;
                margin-left: 0.04rem;
                color: #fdb149;
              }
            }
            .section_right {
              .sp_icon {
                color: #dddddd;
                font-size: 0.12rem;
                margin-right: 0.2rem;
                i {
                  font-size: 0.15rem;
                }
              }
              .sp_price {
                font-size: 0.12rem;
                font-weight: 600;
                color: #000000;
              }
            }
          }
        }
      }
    }
  }
}
</style>
